import { ArrowUpRight } from "lucide-react";
import Artwork from "./Artwork";
import { Reveal, Eyebrow } from "./Reveal";
import { CONTENT } from "@/content";

export default function Releases() {
  return (
    <section data-testid="releases-section" className="relative pb-28 md:pb-44 px-6 md:px-16 max-w-[1600px] mx-auto">
      <Reveal className="flex items-end justify-between mb-12 md:mb-16">
        <h2 className="font-display font-extrabold uppercase tracking-tight leading-none text-4xl sm:text-6xl lg:text-7xl text-[#f5f3ef]">
          RELEASES
        </h2>
        <Eyebrow className="hidden sm:block">DISCOGRAPHY</Eyebrow>
      </Reveal>

      <div className="grid grid-cols-1 md:grid-cols-12 gap-6 md:gap-8">
        {CONTENT.releases.map((r, i) => (
          <Reveal key={r.title} delay={0.06 * i} className={r.span}>
            <div data-testid={`release-card-${i}`} className="group relative overflow-hidden cursor-pointer">
              <Artwork
                variant={r.variant}
                image={r.image}
                alt={`${r.title} — Cover Artwork`}
                className="w-full aspect-square transition-transform duration-[1400ms] ease-[cubic-bezier(0.16,1,0.3,1)] group-hover:scale-[1.045]"
              >
                <div className="absolute inset-0 bg-gradient-to-t from-[#070709]/95 via-[#070709]/20 to-transparent opacity-70 md:opacity-0 md:group-hover:opacity-100 md:transition-opacity md:duration-700" />
                <div className="absolute inset-x-0 bottom-0 p-6 md:p-8 flex items-end justify-between md:translate-y-4 md:opacity-0 md:group-hover:translate-y-0 md:group-hover:opacity-100 md:transition-all md:duration-700 md:ease-[cubic-bezier(0.16,1,0.3,1)]">
                  <div>
                    <p className="font-mono2 text-[10px] tracking-[0.3em] text-[#38bdf8] uppercase mb-2">{r.meta}</p>
                    <h3 className="font-display font-bold uppercase tracking-tight text-2xl md:text-3xl text-[#f5f3ef]">
                      {r.title}
                    </h3>
                  </div>
                  <a
                    data-testid={`release-listen-${i}`}
                    href={r.url || "#"}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="hidden md:flex items-center gap-2 font-mono2 text-[11px] tracking-[0.3em] text-[#f5f3ef] hover:text-[#70c7fa] transition-colors"
                  >
                    LISTEN <ArrowUpRight className="w-4 h-4" />
                  </a>
                </div>
              </Artwork>
            </div>
          </Reveal>
        ))}
      </div>
      <Reveal className="mt-14 md:mt-20">
        <div data-testid="platform-links" className="border-t border-white/10 pt-8 flex flex-wrap items-center gap-x-8 gap-y-3">
          <span className="font-mono2 text-[10px] tracking-[0.35em] text-[#64646e] uppercase">STREAMEN AUF</span>
          {CONTENT.streaming.map((s) => (
            <a
              key={s.name}
              data-testid={`platform-link-${s.name.toLowerCase().replace(/\s+/g, "-")}`}
              href={s.url}
              target="_blank"
              rel="noopener noreferrer"
              className="font-mono2 text-[11px] tracking-[0.3em] text-[#a3a3ac] hover:text-[#70c7fa] transition-colors duration-300 uppercase"
            >
              {s.name} ↗
            </a>
          ))}
        </div>
      </Reveal>
    </section>
  );
}
